import React, { Fragment, Component } from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import lensOutline from "../../images/lens_outline.svg"
import tracisLogoColor from "../../images/tracis_horiz_color_large.png"
import css from "./PrintableLenses.module.css"
import { MODE } from "./CombinedLensModal"
import { toDayMonthTime, generateTimeString, year } from "../../helpers/date"

const Surface = ({ mode, name, images }) => {
  return (
    <div className={cx(css.rearContainer, css[name])}>
      {images.length > 0 ? (
        images.map((image) => (
          <div key={image} className={css.imageContainer}>
            <img
              className={css.surfaceImage}
              alt={`${mode} surface`}
              src={image}
            />
          </div>
        ))
      ) : (
        <div className={cx(css.surfaceImage, css.fullWidth)}>
          <div className={css.noContainer}>{`No ${mode}`}</div>
        </div>
      )}
      <img
        className={cx(css.lensOutline, {
          [css.outlineHidden]: images.length > 0 && mode === MODE.SCANS,
        })}
        src={lensOutline}
        alt="lens outline"
      />
      <span className={css.surfaceLabel}>{name}</span>
    </div>
  )
}

Surface.propTypes = {
  mode: PropTypes.string,
  name: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.string),
}

const Lens = ({ lens, mode }) => {
  return (
    <div className={css.lensContainer}>
      <header className={css.lensHeader}>{lens.name}</header>
      <div className={css.lens}>
        <div className={css.detailsContainer}>
          <div className={css.focalLength}>{`${lens.focalLength}mm`}</div>
          {lens.timestamp && (
            <div className={css.serialNumber}>{`${toDayMonthTime(
              lens.timestamp.seconds
            )} ${year(lens.timestamp.seconds)} ${generateTimeString(
              lens.timestamp.seconds
            )}`}</div>
          )}
          <div className={css.serialNumber}>{`SN: ${lens.serialNumber}`}</div>
          {lens.notes.length > 0 &&
            lens.notes.map((note) => (
              <div key={note.id} className={css.note}>
                {note.note}
              </div>
            ))}
        </div>
        <Surface mode={mode} name="rear" images={lens.rearImages} />
        <Surface mode={mode} name="front" images={lens.frontImages} />
      </div>
    </div>
  )
}

Lens.propTypes = { lens: PropTypes.object, mode: PropTypes.string }

// PrintableLenses needs to be a class component so it
// plays nice with useReactToPrint.
class PrintableLenses extends Component {
  render() {
    return (
      <div className={css.printableLensWrapper}>
        {this.props[this.props.mode].map((lens, i) => (
          <Fragment key={lens.serialNumber}>
            {i % 3 === 0 && (
              <>
                <div className="page-break" />
                <header className={cx(css.showOnPrintout, css.pageHeader)}>
                  {this.props.customLogoPath ? (
                    <img
                      src={this.props.customLogoPath}
                      className={cx(css.showOnPrintout, css.colorLogo)}
                      alt="Other companies logo"
                    />
                  ) : (
                    <div></div>
                  )}
                  <div
                    className={cx(css.showOnPrintout, css.certifiedByContainer)}
                  >
                    <div className={cx(css.showOnPrintout, css.certifiedBy)}>
                      Certified by
                    </div>
                    <img
                      src={tracisLogoColor}
                      className={cx(css.showOnPrintout, css.tracisLogo)}
                      alt="Tracis Logo"
                    />
                  </div>
                </header>
              </>
            )}
            <Lens lens={lens} {...this.props} />
          </Fragment>
        ))}
      </div>
    )
  }
}

PrintableLenses.propTypes = {
  scans: PropTypes.arrayOf(PropTypes.object),
  scratches: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.string,
  customLogoPath: PropTypes.string,
}

export default PrintableLenses
